import request from './request'

export interface FacilityDto {
    createTime?: string;
    createUserId?: number;
    deleteFlag?: number;
    /**
     * 设备id
     */
    id?: number;
    ids?: string;
    /**
     * 设备名称
     */
    name?: string;
    /**
     * sn码
     */
    snCode?: string;
    type?: number;
    updateTime?: string;
    updateUserId?: number;
    serveCompanyId?: number;
    [property: string]: any;
}

export interface CompanyFacilityDto {
    /**
     * 设备总数
     */
    facilityCount?: number;
    facilityList?: FacilityDto[];
    /**
     * 企业id
     */
    serveCompanyId?: number;
    /**
     * 企业名称
     */
    serveCompanyName?: string;

    [property: string]: any;
}

export interface AddCompanyFacilityDto {
    /**
     * 考勤机名称
     */
    name: string;
    /**
     * sn码
     */
    snCode: string;
    /**
     * 派遣单位id
     */
    serveCompanyId: number;
    /**
     * 考勤机类型(0:碰一碰卡片)
     */
    type: number;
}
export interface getAttendanceRecordDto {
    endDate?: string;
    facilityId?: string;
    pageNum?: string;
    pageSize?: string;
    serveCompanyId?: string;
    startDate?: string;
    [property: string]: any;
}
export interface getAttendanceRecordResponseDto {
    code: number;
    data: getAttendanceRecordData;
    msg: string;
    [property: string]: any;
}

export interface getAttendanceRecordData {
    hasNextPage: boolean;
    list: List[];
    totalCount: number;
    [property: string]: any;
}

export interface List {
    checkInRecordList?: CheckInRecordList[];
    /**
     * 身份证号
     */
    idCardNo?: string;
    /**
     * 是否注册(0：否，1：是)
     */
    isRegister?: null;
    /**
     * 手机号
     */
    phone?: string;
    /**
     * 用户id
     */
    userId?: number;
    /**
     * 姓名
     */
    userName?: string;
    [property: string]: any;
}

export interface CheckInRecordList {
    /**
     * 日期
     */
    date?: string;
    /**
     * 第一次打卡
     */
    firstCheckIn?: null;
    /**
     * 最后打卡
     */
    lastCheckIn?: null;
    /**
     * 原始记录
     */
    originalRecord?: null;
    /**
     * 星期
     */
    weekday?: string;
    [property: string]: any;
}

export const getCompanyFacilityList = async (): Promise<CompanyFacilityDto[]> => {
    return request.get('/rest/pay/serve/company/facility/merge/facilityList')
}

// 编辑考勤机
export const editCompanyFacility = async (data: any): Promise<CompanyFacilityDto[]> => {
    return request.put('/rest/pay/serve/company/facility/merge/edit', data)
}

export const deleteCompanyFacility = async (data: { id: number }): Promise<boolean> => {
    return request.post('/rest/pay/serve/company/facility/merge/deleteFacility', data)
}

// 新增考勤机
export const addCompanyFacility = async (data: AddCompanyFacilityDto): Promise<CompanyFacilityDto[]> => {
    return request.post('/rest/pay/serve/company/facility/merge/add', data)
}

// 查询考勤机打卡名单
export const getAttendanceRecordList = async (data: getAttendanceRecordDto): Promise<{ list: getAttendanceRecordResponseDto[], totalCount: number}> => {
    return request.get('/rest/pay/attendance/record/getAttendanceRecord', { params: data })
}
export const exportAttendanceRecord = async (data: getAttendanceRecordDto): Promise<any> => {
    return request.get('/rest/pay/attendance/record/exportAttendanceRecord', { params: data })
}

export interface CalculateWorkingHoursParams {
    /**
     * 结束时间
     */
    endDate?: string;
    /**
     * 设备id
     */
    facilityId?: string;
    /**
     * 身份证号
     */
    idCardNo?: string;
    /**
     * 下班时间
     */
    offWorkTime?: string;
    pageNum?: string;
    pageSize?: string;
    /**
     * 工价(priceType=0:时薪，priceType=1:固定金额)
     */
    price?: string;
    /**
     * 工价(0:按小时,1:固定金额)
     */
    priceType?: string;
    /**
     * 取整方式(0:进一计算,1:退一计算,2:精确计算)
     */
    roundType?: string;
    /**
     * 企业id
     */
    serveCompanyId?: string;
    /**
     * 班次(0:白班,1:夜班)
     */
    shiftType?: string;
    /**
     * 开始时间
     */
    startDate?: string;
    /**
     * 取整分钟数
     */
    thresholdMinutes?: string;
    /**
     * 上班时间
     */
    toWorkTime?: string;
    /**
     * 工时上限
     */
    workHourLimit?: string;
    /**
     * 工时上限减小时数
     */
    workHourLimitReduce?: string;
    [property: string]: any;
}

export const calculateWorkingHours = async (params: CalculateWorkingHoursParams): Promise<{ estimateAmount: number, list: any[], totalCount: number }> => {
    return request.get('/rest/pay/attendance/record/calculateWorkingHours', { params })
}

export const exportWorkHours = async (params: CalculateWorkingHoursParams): Promise<any> => {
    return request.get('/rest/pay/attendance/record/exportWorkHours', { params })
}
